/* eslint-disable no-unused-vars */
import {
  Button,
  Grid,
  Tabs,
  Tab,
  Typography,
  Box,
  CardContent,
  Card,
} from "@mui/material";
import { makeStyles, withStyles } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import PDialog from "../../components/pos/PDialog";
import db from "../../db/db";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { blue, green, grey, orange, red, yellow } from "@mui/material/colors";
import { styled } from "@mui/system";
import API from "../../utils/API";
import ChairIcon from "@mui/icons-material/Chair";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";

const useStyles = makeStyles({});

const theme = createTheme({});

const TableButton = styled(Button)({
  width: "100%",
  fontSize: "0.6rem",
  height: "35px",
});

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default function TableSelecor(props) {
  const { t } = useTranslation();
  const translate = t;

  const [floors, setFloors] = useState([]);
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    initScreen();
  }, []);

  async function initScreen() {
    let { data } = await API.get("/api/v1/salesession/active_sales/dineIn");

    let dbData = await db.floor.toArray();
    for (let f of dbData) {
      let l = JSON.parse(f.layout);
      for (let r of l) {
        for (let c of r) {
          c["tokens"] = [];
        }
      }
      console.log(JSON.stringify(l, null, 4));
      f.layout = l;
    }
    for (let d of data) {
      if (
        d.workflowStatus == "CREATED" ||
        d.workflowStatus == "IN PROGRESS" ||
        d.workflowStatus == "PREPARED" ||
        d.workflowStatus == "BILL CREATED"
      ) {
        for (let t of d.tables) {
          for (let f of dbData) {
            if (f.id == t.floorId) {
              f.layout[t.row][t.col].status = "occupied";

              f.layout[t.row][t.col].tokens.push({
                token: d.token,
                elapsed: d.strElapsed,
                elapsedMin: d.elapsed / 60000,
              });
            }
          }
        }
      }
    }
    setFloors(dbData);
  }

  function handleClickCell(floorIx, rowIx, colIx) {
    let f = [...floors];
    f[floorIx].layout[rowIx][colIx]["selected"] = f[floorIx].layout[rowIx][
      colIx
    ].selected
      ? false
      : true;
    console.log(f);
    setFloors(f);
  }

  function getCellColor(status) {
    if (status) {
      if (status === "vacant") {
        return grey[700];
      } else if (status === "occupied") {
        return green[700];
      }
    } else {
      return grey[700];
    }
  }

  function getLowerCellColor(cell) {
    if (cell.selected) return "white";
    if (cell.status) {
      if (cell.status === "vacant") {
        return blue[900];
      } else if (cell.status === "occupied") {
        return blue[900];
      }
    } else {
      return blue[700];
    }
  }

  function getCellBgColor(cell) {
    if (cell.selected) return orange[700];
    if (cell.status) {
      if (cell.status === "vacant") {
        return grey[700];
      } else if (cell.status === "occupied") {
        return green[200];
      }
    } else {
      return yellow[100];
    }
  }

  const content = (
    <div style={{ height: "600px" }}>
      <ThemeProvider theme={theme}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          {floors.map(
            (item, ix) => item && <Tab label={item.name} {...a11yProps(ix)} />
          )}
        </Tabs>
        {floors.map((floor, floorIx) => (
          <TabPanel value={value} index={floorIx}>
            <Grid container>
              <Grid item xs={12}>
                <table width={"100%"}>
                  <tbody>
                    {floor.layout.map((tableRow, rowIx) => (
                      <tr>
                        {tableRow.map((cell, colIx) => (
                          <td width={"1%"}>
                            {cell.active && (
                              <Grid container style={{ width: "100%" }}>
                                <Grid item xs={12}>
                                  <TableButton
                                    style={{
                                      height: "90px",
                                      padding: "2px",
                                      color: "000",
                                    }}
                                    onClick={() => {
                                      handleClickCell(floorIx, rowIx, colIx);
                                    }}
                                  >
                                    <Grid container>
                                      <Grid
                                        item
                                        xs={12}
                                        style={{
                                          height: "20px",
                                          paddingTop: "5px",
                                          color: "white",
                                          backgroundColor: getCellColor(
                                            cell.status
                                          ),
                                        }}
                                      >
                                        {cell.status ? cell.status : "vacant"}
                                      </Grid>
                                      <Grid
                                        item
                                        xs={6}
                                        style={{
                                          color: getLowerCellColor(cell),
                                          backgroundColor: getCellBgColor(cell),
                                          height: "25px",
                                          fontSize: "18px",
                                        }}
                                      >
                                        {cell.name}
                                      </Grid>
                                      <Grid
                                        item
                                        xs={3}
                                        style={{
                                          textAlign: "right",
                                          height: "25px",
                                          fontSize: "18px",
                                          color: getLowerCellColor(cell),
                                          backgroundColor: getCellBgColor(cell),
                                        }}
                                      >
                                        <ChairIcon
                                          sx={{
                                            fontSize: "18px",
                                            marginTop: "6px",
                                            marginRight: "5px",
                                          }}
                                        ></ChairIcon>
                                      </Grid>
                                      <Grid
                                        item
                                        xs={3}
                                        style={{
                                          textAlign: "left",
                                          color: getLowerCellColor(cell),
                                          fontSize: "18px",
                                          height: "25px",
                                          backgroundColor: getCellBgColor(cell),
                                        }}
                                      >
                                        {cell.chairs}
                                      </Grid>

                                      {cell.tokens.length > 0 &&
                                        cell.tokens.map((tok, colIx, arr) => (
                                          <Grid
                                            item
                                            xs={12 / arr.length}
                                            style={{
                                              color: getLowerCellColor(cell),
                                              backgroundColor:
                                                getCellBgColor(cell),
                                            }}
                                          >
                                            <Grid container>
                                              <Grid
                                                item
                                                xs={12}
                                                style={{ fontSize: "12px" }}
                                              >
                                                {tok.token}
                                              </Grid>
                                              <Grid
                                                item
                                                xs={6}
                                                style={{
                                                  textAlign: "right",
                                                  paddingTop: "2px",
                                                  backgroundColor:
                                                    tok.elapsedMin > 30
                                                      ? red[300]
                                                      : getCellBgColor(cell),
                                                }}
                                              >
                                                <AccessAlarmIcon
                                                  sx={{ fontSize: "medium" }}
                                                ></AccessAlarmIcon>
                                              </Grid>
                                              <Grid
                                                item
                                                xs={6}
                                                style={{
                                                  textAlign: "left",
                                                  paddingTop: "3px",
                                                  backgroundColor:
                                                    tok.elapsedMin > 30
                                                      ? red[300]
                                                      : getCellBgColor(cell),
                                                }}
                                              >
                                                {tok.elapsed}
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        ))}

                                      {cell.tokens.length == 0 && (
                                        <Grid
                                          item
                                          xs={12}
                                          style={{
                                            height: "45px",
                                            backgroundColor: cell.selected
                                              ? orange[700]
                                              : yellow[100],
                                          }}
                                        ></Grid>
                                      )}
                                    </Grid>
                                  </TableButton>
                                </Grid>
                              </Grid>
                            )}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Grid>
            </Grid>
          </TabPanel>
        ))}
      </ThemeProvider>
    </div>
  );

  function onCloseWindow() {
    props.closeWindow(false);
  }

  function onSave() {
    let arr = [];
    for (let f of floors) {
      let rowIx = 0;
      for (let r of f.layout) {
        let colIx = 0;
        for (let cell of r) {
          if (cell.selected) {
            arr.push({
              floorId: f.id,
              tableName: cell.name,
              col: colIx,
              row: rowIx,
            });
          }
          colIx++;
        }
        rowIx++;
      }
    }

    props.setTableInfo(arr);
    onCloseWindow(false);
  }

  return (
    <div>
      <PDialog
        content={content}
        title={"Table Selector"}
        maxWidth={"md"}
        fullWidth={true}
        open={true}
        onCloseWindow={onCloseWindow}
        custumClose={false}
        hideSave={false}
        saveLabel={"Select"}
        onSave={onSave}
        borderLess={false}
      ></PDialog>
    </div>
  );
}
